module.exports = __webpack_public_path__ + "static/media/log-bg.f4836689.jpg";